import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=a5fed050&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=a5fed050&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fed050",
  null
  
)

export default component.exports